module.exports = __webpack_public_path__ + "img/product-bg-2.b471c6e0.png";